jQuery(function ($) {
  const $html = $("html");
  const $header = $(".l-header");
  const $drawer = $("#js-drawer");
  const $drawerToggleBtns = $(".js-drawerBtn");
  const $drawerLinks = $drawer.find(".l-drawer__nav-link");
  let drawerScrollPos = 0;
  let isDrawerOpen = false;

  const openDrawer = () => {
    if (!$drawer.length || isDrawerOpen) {
      return;
    }

    drawerScrollPos = $(window).scrollTop();
    $drawer.addClass("open").attr("aria-hidden", "false");
    $drawerToggleBtns.addClass("is-open");
    $header.addClass("js-drawerActive");
    $html.addClass("js-fixed").css({ top: -drawerScrollPos });
    isDrawerOpen = true;
  };

  const closeDrawer = () => {
    if (!$drawer.length || !isDrawerOpen) {
      return;
    }

    $drawer.removeClass("open").attr("aria-hidden", "true");
    $drawerToggleBtns.removeClass("is-open");
    $header.removeClass("js-drawerActive");
    $html.removeClass("js-fixed").css({ top: 0 });
    window.scrollTo(0, drawerScrollPos);
    isDrawerOpen = false;
  };

  const toggleDrawer = () => {
    if (isDrawerOpen) {
      closeDrawer();
    } else {
      openDrawer();
    }
  };

  // ページ内スクロール
  $('a[href^="#"]').on("click", function () {
    const speed = 800;
    const href = $(this).attr("href");
    const target = $(href === "#" || href === "" ? "html" : href);
    const position = target.offset().top - $header.outerHeight(true);

    if (isDrawerOpen) {
      closeDrawer();
    }

    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  // ヘッダーの色切り替え
  const headerHeight = $header.outerHeight();
  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerHeight / 2) {
      $header.addClass("js-headerColor");
    } else {
      $header.removeClass("js-headerColor");
    }
  });

  // ページトップボタン
  const $topBtn = $("#js-scrollTop");
  if ($topBtn.length) {
    $topBtn.on("click", function () {
      $("html,body").animate({ scrollTop: 0 }, 500);
      return false;
    });

    $topBtn.hide();
    $(window).on("scroll", function () {
      if ($(this).scrollTop() > headerHeight) {
        $topBtn.fadeIn();
      } else {
        $topBtn.fadeOut();
      }
    });
  }

  // ドロワーメニュー
  $drawerToggleBtns.on("click", function (event) {
    event.preventDefault();
    toggleDrawer();
  });

  $drawerLinks.on("click", function () {
    if (isDrawerOpen) {
      closeDrawer();
    }
  });

  $(window).on("resize", function () {
    if (!window.matchMedia("(max-width: 767px)").matches) {
      closeDrawer();
    }
  });

  // タブ切り替え
  const $tab = $(".js-tab");
  const $tabItems = $(".c-tab-cont__item");
  $tab.on("click", function () {
    const index = $tab.index(this);
    $tab.removeClass("is-btn-active");
    $(this).addClass("is-btn-active");
    $tabItems.removeClass("is-content-active");
    $tabItems.eq(index).addClass("is-content-active");
  });
});

function scrollView() {
  const options = {
    origin: "bottom",
    distance: "50%",
    duration: 1000,
    delay: 500,
    opacity: 0,
    mobile: true,
    reset: false,
  };

  const fade = {
    duration: options.duration,
  };
  const toTop = {
    duration: options.duration,
    distance: "50%",
  };
  const toRight = {
    duration: options.duration,
    origin: "left",
    distance: "50%",
  };
  const toLeft = {
    duration: options.duration,
    origin: "right",
    distance: "50%",
  };
  const scale = {
    duration: options.duration,
    scale: 1.2,
  };

  ScrollReveal().reveal(".js-sr-fade", fade);
  ScrollReveal().reveal(".js-sr-top", toTop);
  ScrollReveal().reveal(".js-sr-right", toRight);
  ScrollReveal().reveal(".js-sr-left", toLeft);
  ScrollReveal().reveal(".js-sr-img img", scale);

  if (window.matchMedia("(max-width: 767px)").matches) {
    ScrollReveal().reveal(".js-sr-col1", toRight);
    ScrollReveal().reveal(".js-sr-col2", toLeft);
    ScrollReveal().reveal(".js-sr-col3", toRight);
    ScrollReveal().reveal(".js-sr-col4", toLeft);
  } else {
    ScrollReveal().reveal(".js-sr-col1", toTop);
    toTop.delay = 250;
    ScrollReveal().reveal(".js-sr-col2", toTop);
    toTop.delay = 500;
    ScrollReveal().reveal(".js-sr-col3", toTop);
    toTop.delay = 750;
    ScrollReveal().reveal(".js-sr-col4", toTop);
  }
}
scrollView();

// 任意設定用
// 任意設定を行う場合はクラス(js-sr)を付与し、data-sr-option="値"を指定
const sr = ScrollReveal({
  duration: 2000,
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-sr").forEach(function (element) {
    const dataObj = element.dataset;
    const srParams = { duration: 1500 };
    const spParams = { duration: 1500 };

    for (const key in dataObj) {
      if (Object.prototype.hasOwnProperty.call(dataObj, key) && key.startsWith("sr")) {
        if (key.startsWith("srSp")) {
          const srKey = key.slice(4);
          const normalizedKey = srKey.charAt(0).toLowerCase() + srKey.slice(1);
          spParams[normalizedKey] = dataObj[key];
        } else {
          const srKey = key.slice(2);
          const normalizedKey = srKey.charAt(0).toLowerCase() + srKey.slice(1);
          srParams[normalizedKey] = dataObj[key];
        }
      }
    }

    if (window.matchMedia("(max-width: 767px)").matches) {
      sr.reveal(element, spParams);
    } else {
      sr.reveal(element, srParams);
    }
  });
});

// 375px未満用ビューポート調整（必要時のみ使用）
// const adjustViewport = () => {
//   const triggerWidth = 375;
//   const viewport = document.querySelector('meta[name="viewport"]');
//   const value =
//     window.outerWidth < triggerWidth
//       ? `width=${triggerWidth}, target-densitydpi=device-dpi`
//       : "width=device-width, initial-scale=1";
//   viewport.setAttribute('content', value);
// };
// const debouncedFunction = debounce(adjustViewport);
// window.addEventListener('resize', debouncedFunction, false);

// モーダル
// const modal = document.querySelector('.c-modal');
// const openTrigger = document.querySelector('[data-modal-open]');
// const closeTrigger = document.querySelector('[data-modal-close]');
// openTrigger.addEventListener('click', () => {
//   modal.showModal();
// });
// closeTrigger.addEventListener('click', () => {
//   modal.close();
// });

// アコーディオンアニメーション
// アニメーションの時間とイージング
const animTiming = {
  duration: 500,
  easing: "ease-in-out",
};

// アコーディオンを閉じるときのキーフレーム
const closingAnimation = (answer) => [
  {
    height: answer.offsetHeight + "px",
    opacity: 1,
  },
  {
    height: 0,
    opacity: 0,
  },
];

// アコーディオンを開くときのキーフレーム
const openingAnimation = (answer) => [
  {
    height: 0,
    opacity: 0,
  },
  {
    height: answer.offsetHeight + "px",
    opacity: 1,
  },
];

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".c-acd").forEach((el) => {
    const summary = el.querySelector(".c-acd__head");
    const answer = el.querySelector(".c-acd__body");
    summary.addEventListener("click", (event) => {
      event.preventDefault();
      if (el.getAttribute("open") !== null) {
        const closingAnim = answer.animate(closingAnimation(answer), animTiming);

        closingAnim.onfinish = () => {
          el.removeAttribute("open");
        };
      } else {
        el.setAttribute("open", "true");
        answer.animate(openingAnimation(answer), animTiming);
      }
    });
  });
});
